import { instance } from '../instance'

/**
 * Login to project
 *
 * @param {string} signToken
 * @param {object} fingerprint
 * @param {boolean} validate
 * @returns {Promise<AxiosResponse<any>>}
 */
export const login = async ({ fingerprint, signToken }, validate = true) => {
  return instance.post(
    '/v3/auth/token',
    { fingerprint },
    {
      params: {
        validate: Number(validate),
        signToken,
      },
      retryable: false,
      withBasicAuth: true,
    },
  )
}

/**
 * Generator base auth header
 * https://stackoverflow.com/questions/53017125/base64-encoding-fails-for-non-latin-characters
 *
 * @param email
 * @param password
 * @return {string}
 */
export const getBaseAuthHeader = (email, password) => {
  return 'Basic ' + btoa(unescape(encodeURIComponent(email + ':' + password)))
}

/**
 * Reset password request
 *
 * @param {string} email
 * @return {Promise<AxiosResponse<any>>}
 */
export const resetPassword = async ({ email }) => {
  return instance.post('/v1/auth/password/reset', {
    email: email,
  })
}
